import classNames from 'classnames'
import { FC, memo } from 'react'
import { isWeekend } from 'utils/date'

type DataCellProps = React.PropsWithChildren<{
  data: {
    startDate: Date
  }
}>

// Custom template for table cells on Scheduler
export const DataCell: FC<DataCellProps> = memo((props) => {
  return (
    <div
      className={classNames(
        'w-full h-full',
        // Make the background color for the cell of weekend is gray
        isWeekend(props.data.startDate) &&
          'bg-crew-gray-50 dark:bg-crew-gray-800/50'
      )}
    >
      {props.data.startDate.getDate()}
    </div>
  )
})
